import { createContext, useContext } from "react";

interface TableFilterContextType {
  table: any;
  textSearchField: string | null;
  setTextSearchField: (value: string | null) => void;
  textSearchValue: string | null;
  setTextSearchValue: (value: string | null) => void;
  lastUpdated: Date | null;
  setLastUpdated: (value: Date | null) => void;
  applicationDate: Date | null;
  setApplicationDate: (value: Date | null) => void;
  selectedStatuses: string[] | null;
  setSelectedStatuses: (value: string[] | null) => void;
  role: string | null;
  setRole: (value: string | null) => void;
}

const TableFilterContext = createContext<TableFilterContextType>({
  table: null,
  textSearchField: null,
  setTextSearchField: () => null,
  textSearchValue: null,
  setTextSearchValue: () => null,
  lastUpdated: null,
  setLastUpdated: () => null,
  applicationDate: null,
  setApplicationDate: () => null,
  selectedStatuses: null,
  setSelectedStatuses: () => null,
  role: null,
  setRole: () => null,
});

export const useTableFilterContext = () => useContext(TableFilterContext);

export const TableFilterProvider = TableFilterContext.Provider;
